import React from 'react';
import {DataItem, TextInput} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {TextInputMask} from 'react-native-masked-text';
import {IDeveloperField} from 'dromo-uploader-react';

interface DisplayProps {
  value: string;
}

interface Props {
  valueKey: string;
}

export const Import = (
  key: string = 'mobilePhone',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Phone Number (###) ###-####',
  key,
});

const resolveDisplayValue = (value: string) => {
  return value;
};

const PhoneNumberDisplay = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Phone Number</Text>
      <Text style={[Typography.P3]}>{resolveDisplayValue(value)}</Text>
    </DataItem>
  );
};

const PhoneNumberInput = ({valueKey}: Props) => {
  return (
    <TextInput
      valueKey={(valueKey ? valueKey + '.' : '') + 'mobilePhone'}
      name={'Phone Number'}
      required={false}
      keyboardType={'phone-pad'}
      render={props => (
        <TextInputMask
          type="custom"
          {...props}
          options={{
            mask: '(999) 999-9999',
          }}
        />
      )}
    />
  );
};

export const validation = () =>
  Yup.string().required('Phone number is required');

export const Display = PhoneNumberDisplay;
export const Input = PhoneNumberInput;
export const Value = resolveDisplayValue;

export default PhoneNumberInput;
